export * from './resource-unlock.component';
